import { Box, Switch, Typography, Chip } from "@mui/material"
import { IS_PROD } from "../../clients/ClientRegistry"

export function TestProdToggle() {
  // Check if we're running on localhost
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  // If on localhost, show a LOCAL pill instead of the toggle
  if (isLocalhost) {
    return (
      <Box>
        <Chip 
          label="LOCAL" 
          color="warning" 
          variant="filled"
          sx={{ 
            color: 'white',
            backgroundColor: '#ff9800',
            fontWeight: 'bold'
          }}
        />
      </Box>
    );
  }

  const onSwitchChange = () => {
    if (IS_PROD) {
      window.location.href = 'https://dev.jedi.joinautopilot.com';
    } else {
      window.location.href = 'https://jedi.joinautopilot.com';
    }
  }

  return <Box display="flex" flexDirection="row" alignItems="center">
    <Typography component="span" sx={{ color: 'white' }}>PROD</Typography>
    <Switch defaultChecked={!IS_PROD} color={"primary"} onChange={onSwitchChange}/>
    <Typography component="span" sx={{ color: "white" }}>DEV</Typography>
  </Box>
}